import React from "react";
import { HandCoins } from "lucide-react";

/**
 * BestOfferBadge — global pill shown wherever a listing is marked
 * "Best Offer" / "Pay What You Can" (backing field: `pay_what_you_can`).
 *
 * Props:
 *   size: "sm" (grid cards) | "md" (detail page) — defaults to "sm".
 *   testId: override the data-testid (falls back to `best-offer-badge`).
 *
 * Kept dependency-light so it can drop into every listing entry point
 * (Browse grid, KidProfile shop, ParentDashboard listings, ListingDetail,
 * PublicShop, KidWorkspace) without pulling extra context.
 */
export default function BestOfferBadge({ size = "sm", testId, className = "" }) {
  const sizing = size === "md"
    ? "px-3 py-1 text-xs"
    : "px-2 py-0.5 text-[10px]";
  const iconSize = size === "md" ? "w-3.5 h-3.5" : "w-3 h-3";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider bg-gradient-to-r from-amber-300 to-brandPink text-white shadow-soft ${sizing} ${className}`}
      data-testid={testId || "best-offer-badge"}
      aria-label="Best offer — open to offers"
      title="This seller is open to Best Offers — you can pick your own price at checkout"
    >
      <HandCoins className={iconSize} />
      Best Offer
    </span>
  );
}
